// @flow

/* eslint-disable-next-line no-unused-vars */
import React, { type Node } from 'react';

import {
  isolateComponent,
  labelStyles,
  withModifier,
} from '@zapier/common-utils';

/** @jsx isolateComponent */

type Props = {
  /** List Item renderer */
  itemRenderer: (*, number) => Node,
  /** Loaded items */
  items: Array<*>,
  /** Gap Spacing for list items */
  gap?: number,
  /** Function that takes (item, index) and returns the row key */
  getKey: (*, number) => string | number,
};

const getKeyDefault = (item: *, i: number): number => i;

const defaultProps = {
  getKey: getKeyDefault,
};

const Styles = labelStyles(__filename, {
  root: (props: Props) => [
    {
      listStyleType: 'none',
      margin: 0,
      marginBlockEnd: 0,
      marginBlockStart: 0,
      padding: 0,
      paddingInlineStart: 0,
      WebkitMarginAfter: 0,
      WebkitMarginBefore: 0,
      WebkitPaddingStart: 0,
    },
    props.gap &&
      withModifier('gap', {
        display: 'grid',
        gridGap: props.gap,
      }),
  ],
});

/**
 * Shows a list of items
 */
const List = (props: Props) => {
  const listItems = props.items.map((item, i) => (
    <li key={props.getKey(item, i)}>{props.itemRenderer(item, i)}</li>
  ));

  return <ul css={Styles.root(props)}>{listItems}</ul>;
};

List.defaultProps = defaultProps;

export default List;
